"use client";
import { useEffect } from 'react';

export default function HomeLandingReady() {
  useEffect(() => {
    window.__pteReactReady = true;
    window.pteLandingTracking?.record('react_ready');
    window.dispatchEvent(new Event('pte-react-ready'));
  }, []);
  return null;
}
